var Quantity = /** @class */ (function () {
    function Quantity() {
        this.selectors = {
            container: '[data-quantity]',
            input: '[data-quantity-input]',
            add: '[data-quantity-add]',
            subtract: '[data-quantity-subtract]'
        };
        this.nodeList = {
            containers: document.querySelectorAll(this.selectors.container)
        };
    }
    Quantity.prototype.init = function () {
        var _this = this;
        this.nodeList.containers.forEach(function (container) {
            var add = container.querySelector(_this.selectors.add);
            var subtract = container.querySelector(_this.selectors.subtract);
            var input = container.querySelector(_this.selectors.input);
            add.addEventListener('click', _this.handleAddClick.bind(_this, input));
            subtract.addEventListener('click', _this.handleSubtractClick.bind(_this, input));
        });
    };
    Quantity.prototype.handleAddClick = function (input) {
        input.value = (parseInt(input.value) + 1).toString();
        input.setAttribute("value", (parseInt(input.value)).toString());
    };
    Quantity.prototype.handleSubtractClick = function (input) {
        var value = (parseInt(input.value) - 1).toString();
        input.value = value <= input.min ? input.min : value;
        input.setAttribute("value", value <= input.min ? input.min : value);
    };
    return Quantity;
}());
export { Quantity };
;
